import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import Joined from "./Joined";
import reportWebVitals from "./reportWebVitals";
import { ThemeProvider } from "@material-tailwind/react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import About from "./About";
import ReactGA from "react-ga4";


const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
ReactGA.initialize("G-LQ1R1SSPVD");
const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
  },
  {
    path: "/joined",
    element: <Joined />,
  },
  {
    path: "/about",
    element: <About />,
  },
]);
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <RouterProvider router={router} />
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
